import MoviesAndComingmovies from "./MoviesAndComingmovies";
import Footer from "../footer/Footer";
import MyLocation from "../person-location/MyLocation";

const Mainpage = () => {
  return (
    <div>
      <MoviesAndComingmovies />
      <Footer />
      <MyLocation/>
    </div>
  );
};

export default Mainpage;
